var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSbp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 120,
    viewBox: "0 0 239 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.394 46.526V75.864H196.918V55.284H186.831V75.864H176.355V46.524H207.394V46.526Z",
    fill: "#9FA1B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.84 76.913C164.218 76.913 171.182 71.163 171.182 62.446C171.182 54.009 166.044 48.531 157.457 48.531C153.494 48.531 150.224 49.926 147.761 52.333C148.349 47.358 152.556 43.726 157.188 43.726C158.257 43.726 166.305 43.709 166.305 43.709L170.856 35C170.856 35 160.752 35.23 156.055 35.23C145.323 35.417 138.074 45.172 138.074 57.02C138.074 70.823 145.144 76.913 154.84 76.913ZM154.897 56.245C158.379 56.245 160.793 58.533 160.793 62.445C160.793 65.966 158.648 68.867 154.897 68.875C151.309 68.875 148.895 66.187 148.895 62.505C148.895 58.592 151.309 56.245 154.897 56.245Z",
    fill: "#9FA1B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.547 66.042C129.547 66.042 127.073 67.468 123.378 67.738C119.13 67.864 115.345 65.181 115.345 60.414C115.345 55.764 118.685 53.099 123.271 53.099C126.083 53.099 129.803 55.048 129.803 55.048C129.803 55.048 132.525 50.053 133.935 47.555C131.353 45.598 127.914 44.525 123.914 44.525C113.819 44.525 106 51.107 106 60.355C106 69.721 113.349 76.15 123.914 75.956C126.867 75.846 130.941 74.809 133.424 73.214L129.547 66.042Z",
    fill: "#9FA1B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.12L14.532 52.095V67.939L0.017 93.863L0 26.12Z",
    fill: "#9FA1B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7971 42.643L69.4141 34.297L97.2821 34.271L55.7971 59.685V42.643Z",
    fill: "#9FA1B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.72 25.967L55.797 60.357L41.231 51.407V0L55.72 25.967Z",
    fill: "#9FA1B0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.282 34.271L69.413 34.297L55.72 25.967L41.231 0L97.282 34.271Z",
    fill: "#9FA1B0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.797 94.007V77.322L41.231 68.542L41.239 120L55.797 94.007Z",
    fill: "#9FA1B0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.38 85.737L14.531 52.095L0 26.12L97.223 85.703L69.38 85.737Z",
    fill: "#9FA1B0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.24 120L55.796 94.007L69.379 85.737L97.222 85.703L41.24 120Z",
    fill: "#9FA1B0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0170898 93.863L41.3501 68.543L27.4541 60.017L14.5321 67.939L0.0170898 93.863Z",
    fill: "#9FA1B0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbp);
export default __webpack_public_path__ + "static/media/sbp.669b8a961b11fddc2953bbe9588a2c54.svg";
export { ForwardRef as ReactComponent };